import { FC } from "react";
import { Box, Typography } from "@material-ui/core";

const ParagraphContent: FC<{ paragraphs: string[] }> = ({ paragraphs }) => (
  <Typography variant="body2" component="div">
    {paragraphs.map((paragraph, i) => (
      <Box key={i} my={2}>
        {paragraph}
      </Box>
    ))}
  </Typography>
);

export default ParagraphContent;
